import {Component, forwardRef, Inject, Input, OnDestroy, OnInit} from '@angular/core';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';
import {ClientService} from "./services/client.service";
import {Router} from "@angular/router";
import {AlertService} from "./services/alert.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {TranslateService} from "@ngx-translate/core";
import {SessionService} from "./services/session.service";
import {UIService} from "./services/ui.service";

/*
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app works!';
}
*/

@Component({
  // selector: 'app-root',
  selector: 'body',
  templateUrl: './app.component.html',
  // host: {
  //   // '[style.background-color]': 'bodyBackgroundColor()',
  //   ''
  // },
})
export class AppComponent implements OnInit, OnDestroy {

  @Input() isBackgroundVisible = true;
  @Input() myBackgroundColor = '#234556';
  // public angularclassLogo = 'assets/img/angularclass-avatar.png';
  // public name = 'Angular 2 Webpack Starter';
  // public url = 'https://twitter.com/AngularClass';

  constructor(

    @Inject(forwardRef(() => AlertService)) private alertService: AlertService,
    @Inject(forwardRef(() => ClientService)) private clientService: ClientService,
    @Inject(forwardRef(() => DomSanitizer)) private domSanitizer: DomSanitizer,
    @Inject(forwardRef(() => NgbModal)) private modalService: NgbModal,
    @Inject(forwardRef(() => Router)) private routing: Router,
    @Inject(forwardRef(() => TranslateService)) private translate: TranslateService,
    @Inject(forwardRef(() => UIService)) private uiService: UIService,
    @Inject(forwardRef(() => SessionService)) public session: SessionService,
  ) {

  }

   // constructor(private sanitizer: DomSanitizer, private clientService: ClientService) {
   //
   //
   // }


   /*
     this.clientService.remoteLoginClient(token).then(
      (res) => {
        this._processLoginInfo(res)
      }
    );
    */


  public ngOnInit() {
    /*
    this.clientService.loadUIConfiguration().then(
      (res)=>{
        const serial = new JSonSerializer();
        const tmp = new UIConfiguration(this.alertService,this.domSanitizer,this.modalService,this.translate);
        serial.deserialize(res,tmp);
        this.session.uiConfiguration = tmp;
      }
    );
    */


  }

  ngOnDestroy(): void {
    console.log('Destroying AppComponent');
  }

  public bodyBackgroundImage(): SafeStyle {
     console.log('bodyBackgroundImage ');
    // return '#449955';
    const style = 'url(../assets/img/bck-2.jpg) no-repeat center center fixed';
     const safeStyle = this.domSanitizer.bypassSecurityTrustStyle(style);
    console.log('bodyBackgroundImage ' + safeStyle);
    return safeStyle;
  }

  public bodyBackgroundColor(): string {
     return '#394a6b';
  }


  public color(): string{
    console.log('On Color...');
    return '#223344';
  }
}
